import { render } from "./PhoneLookup.vue?vue&type=template&id=7fd63472"
import script from "./PhoneLookup.vue?vue&type=script&lang=js"
export * from "./PhoneLookup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__